<div class="feedback-content-block">
    <button *ngIf="windowWidth >= 1200" class="btn feedback-btn" type="button" (click)="openFeedbackDialog();">

        Feedback</button>

    <button *ngIf="windowWidth <1200" class="btn feedback-btn" type="button" (click)="openFeedbackDialog();">

        Feedback</button>

    <!-- connect with saradha about this comment -->
    <!--  <button *ngIf="windowWidth < 1200" (click)="openFeedbackDialog()" color="warn" class="feedback-icon-block float-right ml-auto d-flex review-comment-icon"
        mat-fab>
        <span class="fa fa-commenting-o" style="font-size:35px;margin-top: -5px;margin-left: 12px;"></span>
    </button> -->
</div>